module.exports = __webpack_public_path__ + "static/media/pngIcon.1387f036.svg";